import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config";
import axiosClient from "../../../common/api/request";

// A 500 or a body that is not an object reads as the request's own message,
// the same rule the report downloads use for their error toasts.
const toRejectValue = (error) =>
  error?.response?.data &&
  typeof error.response.data === "object" &&
  error?.response?.status !== 500
    ? error.response.data
    : { Error: error?.message };

const createTaxesThunk = (endpoint) =>
  createAsyncThunk(
    `taxesV3/${endpoint}`,
    async (params, { rejectWithValue }) => {
      try {
        return await axiosClient.get(`${config.API_URL_V3}/taxes/${endpoint}/`, {
          params,
        });
      } catch (error) {
        return rejectWithValue(toRejectValue(error));
      }
    }
  );

export const getTaxesSummary = createTaxesThunk("summary");
export const getTaxesTypes = createTaxesThunk("types");
export const getTaxesDaily = createTaxesThunk("daily");
export const getTaxesBreakdowns = createTaxesThunk("breakdowns");
export const getTaxesDetails = createTaxesThunk("details");
export const getTaxesInsights = createTaxesThunk("insights");
export const getTaxesInsightsHourly = createTaxesThunk("insights/hourly");
export const getTaxesInsightsBreakdowns = createTaxesThunk(
  "insights/breakdowns"
);
export const downloadTaxes = createTaxesThunk("download");
